import { _ } from '../utils'
import axios from 'axios'
import config from './../config/main'

export default function ForumMove(element) {
    const moveButton = element
    moveButton.addEventListener('change', (el) => {
        const url = el.target.dataset.url,
            forumId = el.target.options[el.target.selectedIndex].value

        axios
            .get(url, { params: { forumId: forumId }, header: config.axiosHeader })
            .then((response) => {
                const subForumSelect = document.getElementById('subforumId')

                // remove all options
                const L = subForumSelect.options.length - 1
                for (let i = L; i >= 0; i--) {
                    subForumSelect.remove(i)
                }

                // add in new options..
                response.data.forEach((option) => {
                    const opt = document.createElement('option')
                    opt.appendChild(document.createTextNode(option.label))
                    opt.value = option.value
                    subForumSelect.appendChild(opt)
                })
            })
            .catch((errors) => console.warn(errors))
        return true
    })
}
